<template>
	<section>
		<div v-if="$route.path == '/Order/SaleOrder'">
			<el-form :inline="true" class="toolbar" style="padding-bottom: 0px">
				<el-form-item label="销售下单号:" label-width="100px">
					<el-input v-model="query.OrderCode"></el-input>
				</el-form-item>
				<el-form-item label="代理商:" label-width="80px">
					<el-input v-model="query.AgentName"></el-input>
				</el-form-item>
	
				<el-form-item label="所属区域:" label-width="80px" v-show="false">
					<el-input v-model="query.AreaName"></el-input>
				</el-form-item>
				
				<el-form-item label="审核状态:" label-width="80px">
					<el-select placeholder="-请选择-" class="formlength" v-model="query.OrderStatus">
						<el-option v-for="option in queryType" :value="option.TypeValue" :label="option.TypeName">
						</el-option>
					</el-select>
				</el-form-item>
	
				<el-form-item label="发货状态:" label-width="80px">
					<el-select placeholder="-请选择-" class="formlength" v-model="query.SendStatus">
						<el-option v-for="option in querySort" :value="option.SortValue" :label="option.SortName">
						</el-option>
					</el-select>
				</el-form-item>
				<el-button type="primary" @click="onQuerySubmit" icon="search">查询</el-button>
				<el-button type="primary" @click="onQueryClean" icon="delete2">重置</el-button>
	
			</el-form>
	
			<div class="toolbar">
				<el-button type="primary" size="small" @click="download" icon="arrow-down">导出</el-button>
				<el-button type="primary" size="small" icon="plus" v-on:click="addOrder">新增销售下单</el-button>
				<br/>
				<br/>
				<span>共{{totalSize}}个订单</span>
			</div>
			<div>
				<el-table :data="lists" v-loading="loading2" element-loading-text="拼命加载中" border style="width: 100%;" @selection-change="selsChange" router>
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column label="销售下单号" prop="OrderCode" width="135">
					</el-table-column>
					<el-table-column label="代理商" prop="AgentName" width="200">
					</el-table-column>
					<el-table-column label="所属区域" prop="AreaName" width="200">
					</el-table-column>
					<el-table-column label="业务员" prop="SaleEmployeeName" width="200">
					</el-table-column>
					<el-table-column label="下单人" prop="AddUserName" width="200">
					</el-table-column>
					<el-table-column label="销售下单时间" prop="OrderTime" width="200">
					</el-table-column>
					<el-table-column label="审核人" prop="AuditEmployeeName" width="200">
					</el-table-column>
					<el-table-column label="订单状态" prop="OrderStatusName" width="100">
					</el-table-column>
					<el-table-column label="发货状态" prop="SendStatusName" width="100">
					</el-table-column>
					<el-table-column label="操作" width="360px" fixed="right">
						<template scope="scope">
							<el-button size="small" @click="handleView(scope.$index, scope.row)" icon="search" type="success">查看</el-button>
							<el-button size="small" @click="handleEdit(scope.$index, scope.row)" icon="edit" :disabled="(scope.row.btnVue&4)<=0" type="primary">修改</el-button>
							<el-button size="small" @click="handleDel(scope.$index, scope.row)" icon="delete" :disabled="(scope.row.btnVue&8)<=0" type="danger">删除</el-button>
							<!--<el-button size="small" @click="handleSkipOrder(scope.$index, scope.row)" :disabled="(scope.row.btnVue&256)<=0" type="info">生成发货单</el-button>-->
							<el-button size="small" @click="handleInvalid(scope.$index, scope.row)" :disabled="(scope.row.btnVue&16)<=0" icon="delete" type="warning">作废</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-col :span="24" class='btm-action'>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize*1" style="float: right">
				</el-pagination>
			</el-col>
		</div>
		<div v-else>
			<router-view></router-view>
		</div>
	</section>
</template>

<script>
import { GetAgentList, GetOrderByPage, GetOrderExport, ERP_OrderDel, ERP_InvalidOrder } from '../../api/orderApi';
import {
	util
} from '../../common/js/util.js';
import NProgress from 'nprogress'
export default {
	data() {
		return {
			Session: util.getSessin(),
			//发货状态
			querySort: [{ "SortName": "全部", "SortValue": "-1" }, { "SortName": "未发货", "SortValue": "0" }, { "SortName": "部分发货", "SortValue": "1" }, { "SortName": "全部发货", "SortValue": "2" }],
			//收货状态
			queryType: [{ "TypeName": "全部", "TypeValue": "-1" }, { "TypeName": "待审核", "TypeValue": "0" }, { "TypeName": "审核通过", "TypeValue": "1" }, { "TypeName": "驳回", "TypeValue": "2" }, { "TypeName": "已作废", "TypeValue": "3" }],
			loading2: false,
			lists: [{ "Id": "346567788" }],
			pageIndex: 1,
			pageSize: 10,
			totalSize: '',
			sels: [],//列表选中列
			pageSizes: [10, 20, 50],
			query: {
				OrderCode: "",
				AgentName: "",
				AreaName: "",
				OrderStatus: "",
				SendStatus: ""
			}

		}
	},
	methods: {
		handleSkipOrder(index, row) {
			util.redirect(this, '/Order/SaleOrder/CreateSkipOrder?Id=' + row.OrderId, false);
		},//生成发货通知单
		handleInvalid(index, row) {
			this.$confirm('确认作废订单吗？', '提示', {}).then(() => {
				/* var ids = this.sels.map(item => item.ProductId).toString();*/
				var ids = row.OrderId;
				var Params = { Sid: this.Session[0], Session: this.Session[1], OrderId: ids };
				ERP_InvalidOrder(Params).then(res => {
					util.doResult(this, res,() => {
							this.$notify({
								title: '成功',
								message: "作废订单成功",
								type: 'success'
							});
							this.List();
						}
					);
				})
			})
		},//作废订单
		handleDel(index, row) {
			this.$confirm('确认删除吗？', '提示', {}).then(() => {
				var ids = row.OrderId;
				var Params = {
					Ids: ids
				};
				ERP_OrderDel(Params).then(res => {
					util.doResult(this, res,
						() => {
							this.$notify({
								title: '成功',
								message: "删除成功",
								type: 'success'
							});
							this.List()
						}
					);
				})
			})
		},//删除订单
		handleView(index, row) {
			util.redirect(this, '/Order/SaleOrder/ViewOrder?Id=' + row.OrderId, false);
		},//查看订单
		handleEdit(index, row) {
			util.redirect(this, '/Order/SaleOrder/addOrder?Id=' + row.OrderId, false);
		},//编辑订单
		//新增销售下单
		addOrder: function () {
			this.$router.push("/Order/SaleOrder/addOrder");
		},//添加订单
		//初始化加载页面
		List() {
			this.lists = [];
			this.loading2 = true;//拼命加载中显示
			var para = this.getParams()
			GetOrderByPage(para).then(res => {
				util.doResult(this, res,() => {});
				let { StateCode, StateMsg, Data, Cnt } = res.data;
				for (var i = 0; i < Data.length; i++) {
					Data[i].AreaName = Data[i].AreaName.split("市")[0] + '市'
					if (Data[i].AreaName == "北京北京市") {
						Data[i].AreaName = "北京市"
					}
					if (Data[i].AreaName == "重庆重庆市") {
						Data[i].AreaName = "重庆市"
					}
					if (Data[i].AreaName == "上海上海市") {
						Data[i].AreaName = "上海市"
					}
					if (Data[i].AreaName == "天津天津市") {
						Data[i].AreaName = "天津市"
					}
					if (Data[i].AuditEmployeeName == '') {
						Data[i].AuditEmployeeName = '--'
					}
				}
				this.outTips(StateCode, StateMsg, Data, Cnt)
			});
		},
		//通用输入参数
		getParams: function () {
			var para = {
				Sid: this.Session[0], Session: this.Session[1], pageIndex: this.pageIndex, pageSize: this.pageSize, orderBy: this.orderBy
			};
			if (this.query.OrderCode != '') {
				para.OrderCode = this.query.OrderCode
			}
			if (this.query.AgentName != '') {
				para.AgentName = this.query.AgentName
			}
			if (this.query.AreaName != '') {
				para.AreaName = this.query.AreaName
			}
			if (this.query.OrderStatus != '') {
				para.OrderStatus = this.query.OrderStatus
			}
			if (this.query.SendStatus != '') {
				para.SendStatus = this.query.SendStatus
			}
			return para
		},
		//通用提示信息
		outTips: function (StateCode, StateMsg, Data, Cnt) {
			if (StateCode !== 0 && StateCode !== 99) {
				this.$notify({
					title: '错误',
					message: StateMsg,
					type: 'error'
				});
			} else {
				this.totalSize = Cnt;
				this.loading2 = false;//拼命加载中隐藏
				this.lists = Data;
			}
		},

		selsChange: function (sels) {
			this.sels = sels;
		},
		//查询
		onQuerySubmit: function () {
			this.pageIndex = 1;
			this.lists = [];
			this.loading2 = true;//拼命加载中显示
			var para = this.getParams()
			GetOrderByPage(para).then(res => {
				util.doResult(this, res,() => {});
				let { StateCode, StateMsg, Data, Cnt } = res.data;
				this.outTips(StateCode, StateMsg, Data, Cnt)
			});
		},//查询功能
		handleSizeChange: function (val) {
			this.pageSize = val;
			this.List();
		},
		onQueryClean: function () {
			this.query.OrderCode = "";
			this.query.AgentName = "";
			this.query.AreaName = "";
			this.query.OrderStatus = "";
			this.query.SendStatus = "";
			this.List();
		},
		//下载文件
		download: function () {
			this.$confirm('确认导出吗？', '提示', {}).then(() => {
				var ids = this.sels.map(item => item.OrderId).toString();
				if (ids == "") {
					var para = this.getParams();
					this.List();
					delete para["pageIndex"];
					delete para["pageSize"];

				} else {
					let _session = util.getSessin();
					var para = {
						Sid: _session[0],
						Session: _session[1],
					};
					para.ids = ids;
				}
				GetOrderExport(para).then(res => {
					util.doResult(this, res,() => {});
					let { StateCode, StateMsg, Data, Cnt } = res.data;
					if (StateCode !== 0 && StateCode !== 99) {
						this.$notify({
							title: '错误',
							message: StateMsg,
							type: 'error'
						});
					} else {
						try {
							let elemIF = document.createElement("iframe");
							elemIF.src = Data;
							elemIF.style.display = "none";
							document.body.appendChild(elemIF);
						} catch (e) {
							this.$notify({
								title: '浏览器不兼容，建议使用谷歌浏览器',
								type: 'error'
							});
						}
					}
				});


			})
		},//导出功能
		handleCurrentChange: function (val) {
			this.pageIndex = val;
			this.List();
		}
	},

	watch: {
		$route: function () {
			if (this.$route.name == "销售下单") {
				this.List();
			}
		}
	},
	created() {
		this.List();
	},

}
</script>

<style lang="scss" scoped>
.btm-action {
	display: flex;
	justify-content: center;
	margin: 5px 0px;
}

.formlength {
	width: 160px;
}
</style>


// WEBPACK FOOTER //
// SaleOrder.vue?1ac7ba9c